
import { Custom_Field_Definition } from '@/schema/custom_fields';
import { parseTime } from '@/utils';
import Vue, { PropType } from 'vue';

export default Vue.extend({
	props: {
		customFieldDefinition: { type: Object as PropType<Custom_Field_Definition>, required: true },
		customFields: { type: Object, required: false, default: () => ({}) }
	},
	computed: {
		value() {
			return this.resolve(this.customFieldDefinition.path, this.customFields);
		}
	},
	methods: {
		renderBoolean() {
			return (
				<input type='checkbox' checked={this.value ? true : false} disabled />
			);
		},
		renderString() {
			return (
				<span>{ this.value }</span>
			);
		},
		renderDate() {
			if (this.value === undefined || this.value === null || this.value === '') {
				return <span></span>;
			}
			return (
				<span>{ parseTime(this.value, '{d}-{m}-{y}') }</span>
			);
		},
		renderInt() {
			return (
				<span>{ this.value }</span>
			);
		},
		renderDecimal() {
			return (
				<span>{ this.value }</span>
			);
		},
		renderCurrency() {
			if (this.value === undefined || this.value === null || this.value === '') {
				return <span></span>;
			}
			const num = Number(this.value);
			const formatted = isNaN(num)
				? this.value
				: num.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
			return (
				<span>€ { formatted }</span>
			);
		},
		resolve(path, obj = self) {
			// https://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-and-arrays-by-string-path
			const resolvePath = (object, path, defaultValue) => path
				.split(/[\.\[\]\'\"]/)
				.filter(p => p)
				.reduce((o, p) => o ? o[p] : defaultValue, object);

			return resolvePath(obj, path, '');
		}
	},
	render() {
		switch (this.customFieldDefinition.type) {
			case 'BOOLEAN' :
				return this.renderBoolean();
			case 'STRING':
				return this.renderString();
			case 'DATE':
				return this.renderDate();
			case 'INT':
				return this.renderInt();
			case 'DECIMAL':
				return this.renderDecimal();
			case 'CURRENCY':
				return this.renderCurrency();
			default:
				return null;
		}
	}
});
